export enum ExportMode {
  CONVERSATIONS = 'conversations',
  DATA_GATHERING = 'data_gathering',
  LINK_TRACKING = 'link_tracking',
  AI_INSIGHTS = 'ai_insights',
  TRIAGE_DATA = 'triage_data',
}

export enum Extension {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export interface UrlToFile {
  url: string;
}

export type ConversationExportResponse = UrlToFile;

export type DataGatheringExportResponse = UrlToFile;

export interface ExportDownloadPayload {
  start_date: string;
  end_date: string;
  extension: Extension;
  query?: string;
  send_email_notification: boolean;
}

export interface ExportApiErrorPayload {
  detail?: string;
  message?: string;
}
